module.exports = __webpack_public_path__ + "img/research-poster.bae1fe5d.jpg";